import { useEffect, useState } from "react";
// import httpClient from "../HTTPService";
import httpClient from "../../../HTTPService";
import moment from "moment";

function ProfitServiceUser() {
  const [rportsList, setReportslist] = useState([])
  const [searchtext, setsearchtext] = useState('')
  const [totalCount, setTotalCount] = useState(0)
  const [currentPage, setCurrentPage] = useState(1);
  const [getLimit, setLimit] = useState(10);
  const items = Array.from({ length: totalCount }, (_, index) => `Item ${index + 1}`);
  const itemsPerPage = 10;
  const totalPages = Math.ceil(items.length / getLimit);
  const startPage = Math.max(1, currentPage - Math.floor(5 / 2));
  const endPage = Math.min(totalPages, currentPage + Math.floor(5 / 2));

  const [memberDetailsLoading, setMemberLoading] = useState(false)
  const [currentmemberdetails, setCurrentmemberdetails] = useState({})
  const [meberdetails, setmeberdetails] = useState([])
  const [totalpayammount, setToalPayamount] = useState({
    payamount: 0,
    up1_amount: 0,
    up2_amount: 0,
    Total_dis: 0,
    net_profit: 0
  })

  const [totalpayammount_detai, setToalPayamount_detai] = useState({
    payamount: 0,
    up1_amount: 0,
    up2_amount: 0,
    Total_dis: 0,
    net_profit: 0
  })

  const [servisedCount, setServisedCount] = useState(0)

  function calcualte_totalpayamount_details(_input) {
    let payamount = 0;
    let up1_amount = 0;
    let up2_amount = 0;
    let Total_dis = 0;
    let net_prarrayofit = 0;
    _input?.forEach(item => {
      payamount += item?.price ? parseFloat(item?.price) : 0;
      up1_amount += item?.level_1_commission ? parseFloat(item?.level_1_commission) : 0;
      up2_amount += item?.level_2_commission ? parseFloat(item?.level_2_commission) : 0;
      Total_dis += item?.total_distribution ? parseFloat(item?.total_distribution) : 0;
      net_prarrayofit += item?.profit ? parseFloat(item?.profit) : 0
    });
    setToalPayamount_detai({
      payamount: payamount?.toFixed(2),
      up1_amount: up1_amount?.toFixed(2),
      up2_amount: up2_amount?.toFixed(2),
      Total_dis: Total_dis?.toFixed(2),
      net_profit: net_prarrayofit?.toFixed(2)
    })
  }
  useEffect(() => {
    getreports(searchtext, currentPage, getLimit);
  }, [currentPage, getLimit]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  //search button

  const searchtxt = () => {
    getreports(searchtext, 1, getLimit);
  }
  //pagiantion

  const Pagination = ({ currentPage, totalPages, onPageChange }) => {
    const pages = [];
    for (let i = 1; i <= totalPages; i++) {
      pages.push(i);
    }
    console.log(currentPage, 'current pages...')
    return (
      <div className="pagination">
        {currentPage > 1 && (
          <button className="pagination-btn" onClick={() => onPageChange(currentPage - 1)}>
            <i className="fa fa-chevron-left" aria-hidden="true"></i>
          </button>
        )}
        {startPage > 1 && (
          <button className="pagination-btn" onClick={() => onPageChange(1)}>
            1
          </button>
        )}
        {startPage > 2 && <span className="pagination-ellipsis">...</span>}
        {pages.slice(startPage - 1, endPage).map(page => (
          <button
            key={page}
            className={`pagination-btn ${page === currentPage ? 'active' : ''}`}
            onClick={() => onPageChange(page)}
          >
            {page}
          </button>
        ))}
        {endPage < totalPages - 1 && <span className="pagination-ellipsis">...</span>}
        {endPage < totalPages && (
          <button className="pagination-btn" onClick={() => onPageChange(totalPages)}>
            {totalPages}
          </button>
        )}
        {currentPage < totalPages && (
          <button className="pagination-btn" onClick={() => onPageChange(currentPage + 1)}>
            <i className="fa fa-chevron-right" aria-hidden="true"></i>
          </button>
        )}
      </div>
    );
  };
  function calcualte_totalpayamount(_input) {
    let payamount = 0;
    let up1_amount = 0;
    let up2_amount = 0;
    let Total_dis = 0;
    let net_prarrayofit = 0;
    _input?.forEach(item => {
      payamount += item?.price ? parseFloat(item?.price) : 0;
      up1_amount += item?.level_1_commission ? parseFloat(item?.level_1_commission) : 0;
      up2_amount += item?.level_2_commission ? parseFloat(item?.level_2_commission) : 0;
      Total_dis += item?.total_distribution ? parseFloat(item?.total_distribution) : 0;
      net_prarrayofit += item?.profit ? parseFloat(item?.profit) : 0
    });
    setToalPayamount({
      payamount: payamount?.toFixed(2),
      up1_amount: up1_amount?.toFixed(2),
      up2_amount: up2_amount?.toFixed(2),
      Total_dis: Total_dis?.toFixed(2),
      net_profit: net_prarrayofit?.toFixed(2)
    })
  }
  // get reports
  const getreports = async (search_name, pagecount, limit) => {
    try {
      const result = await httpClient.post('/admin/used-service-profit-list', {
        search_name, offset: pagecount, limit: limit
      }, {
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      })

      if (result.status === 200) {
        console.log(result.data.data, 'data..')
        setTotalCount(result?.data.total_count)
        setReportslist(result?.data?.data)
        setServisedCount(result?.data?.profile_count)
        calcualte_totalpayamount(result?.data?.data)
      }

    } catch (error) {
      //   toast.error(error.message)
    }
  }

  // fetch member details purchased serviced

  const ftechmemberdetails = async (id) => {
    setMemberLoading(true)
    let _fetchmemberdetails = await httpClient.post('/admin/used-service-profit-details', {
      id: id
    }, {
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      }
    })

    if (_fetchmemberdetails?.status) {
      setmeberdetails(_fetchmemberdetails?.data?.data)
      calcualte_totalpayamount_details(_fetchmemberdetails?.data?.data)
      setMemberLoading(false)
    }
  }

  // debounce function to limit the number of API calss
  function debounce(func, delay) {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => func(...args), delay);
    };
  }
  // search handler function
  const searchHandler = debounce((query) => {
    getreports(query, 1, getLimit);
  }, 2000)
  return (
    <>
      <div className="">
        <div class="search-box">
          <div class="searchtct">

            <i class="fa fa-search" aria-hidden="true"></i>
            <input type="text" name="text" placeholder="Search..."
              onChange={(val) => searchHandler(val.target.value)}
            // onKeyDown={() => {
            //   if (searchtext === '') {
            //     getreports(searchtext, currentPage, getLimit)
            //   }
            // }}
            />
            <button type='button' className='searchBtn' onClick={searchtxt} >Search</button>


          </div>

        </div>
        <div class="row">
          <div class="col-md-12">
            <h5>Used Service: {servisedCount}</h5>

            <div class="table-responsive">
              <table class="table">
                <thead>
                  <tr>
                    <th className="col-1">SL NO</th>
                    <th className="col-1"> User Name & ID</th>
                    {/* <th>
                      Added SubCategory

                    </th> */}
                    <th className="col-1">Pay Amount(<i className="fa fa-inr" />)</th>
                    {/* <th>Date</th> */}
                    <th className="col-1">Up 1 Distribution	</th>
                    <th className="col-1">Up 2 Distribution</th>
                    <th className="col-1">Total Distribution</th>
                    <th className="col-1">Net Profit(<i className="fa fa-inr" />)</th>
                    <th className="col-1">View Details</th>


                  </tr>
                </thead>
                <tbody>

                  {
                    rportsList?.map((item, index) => {
                      return (
                        <tr className="custom-tableback-th">
                          <td className="col-1">{index + 1}</td>
                          <td className="col-1">
                            <div style={{
                              display: 'flex',
                              flexDirection: 'column'
                            }}>
                              <p>{item?.user_name} </p>
                              <p> {item?.user_referral_code} </p>

                            </div>
                          </td>
                          {/* <td>{item?.sub_category_name}</td> */}
                          <td className="col-1 table-td">{item?.price}</td>
                          {/* <td>{moment(item?.date).format('DD-MM-YYYY')}</td> */}
                          <td className="col-1 table-td">{item?.level_1_commission}</td>
                          <td className="col-1 table-td">{item?.level_2_commission}</td>
                          <td className="col-1 table-td"> {item?.total_distribution}</td>
                          <td className="col-1 table-td">{item?.profit}</td>
                          <td className="col-1 table-td">


                            <i
                              onClick={() => {
                                setCurrentmemberdetails(item)
                                ftechmemberdetails(item?.id)
                              }}

                              style={{
                                cursor: 'pointer'
                              }}
                              class="fa fa-eye"
                              data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight" aria-controls="offcanvasRight"
                              aria-hidden="true"></i>
                            <p style={{
                              color: 'red'
                            }}>{item?.count}</p>
                          </td>
                        </tr>
                      )
                    })
                  }
                  <tr className="custom-tableback-th">
                    <td className="col-1"> </td>
                    <td className="col-1">
                      <div style={{
                        display: 'flex',
                        flexDirection: 'column'
                      }}>
                        <p> </p>
                        <p> </p>

                      </div>
                    </td>
                    {/* <td>{item?.sub_category_name}</td> */}
                    <td className="col-1 table-td">TO: {totalpayammount?.payamount}</td>
                    {/* <td>{moment(item?.date).format('DD-MM-YYYY')}</td> */}
                    <td className="col-1 table-td">TO: {totalpayammount?.up1_amount}</td>
                    <td className="col-1 table-td">TO: {totalpayammount?.up2_amount}</td>
                    <td className="col-1 table-td">TO: {totalpayammount?.Total_dis}</td>
                    <td className="col-1 table-td">TO: {totalpayammount?.net_profit}</td>
                    <td className="col-1 table-td">



                    </td>
                  </tr>
                </tbody>
              </table>
              <div className='nodata-found-div'>
                {
                  rportsList?.length == 0 ?
                    <p>No Data Found</p>
                    //  <img 
                    //  className='table-image'
                    //  src={require('../../assets/OIP.png')}/>
                    : null
                }
              </div>
            </div>
          </div>
        </div>
        {/* <div class="row total_amount_display">
          <div class="col-md-8">
            <div class="table-responsive">
              <table class="table">
                <thead>
                  <tr>
                    <th>SL NO</th>
                  </tr>
                </thead>
              </table>
            </div>
          </div>
        </div> */}

        <div class="tablepgntn">
          <p>Show <select value={getLimit} onChange={(val) => {
            setLimit(val.target.value);
            setCurrentPage(1)
          }}>
            <option value={10}>10</option>
            <option value={20}>20</option>
            <option value={30}>30</option>
            <option value={40}>40</option>
            <option value={50}>50</option>
          </select> Entries</p>
          <ul>

          </ul>
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
          />

        </div>

      </div>

      {/* right sidebar */}
      <div
        style={{ width: '80vw', maxWidth: '80vw', height: '100vh' }}
            class="offcanvas offcanvas-end " tabindex="-1" id="offcanvasRight" aria-labelledby="offcanvasRightLabel">
        <div class="offcanvas-header">
          <h5 class="offcanvas-title" id="offcanvasRightLabel">Details</h5>
          <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>

        </div>
        <div style={{
          paddingLeft: 20
        }}>
          <h6>User Name: {currentmemberdetails?.user_name}</h6>
          <h6>Member ID: {currentmemberdetails?.user_referral_code}</h6>
        </div>
        {
          memberDetailsLoading ? (
            <>
              <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                padding: 10
              }}>

                <span class="loader"></span>
              </div>
            </>
          )
            :
            (
              <div class="offcanvas-body">
                <div class="row">
                  <div class="col-md-12">
                    <div class="table-responsive">
                      <table class="table">
                        <thead>
                          <tr>
                            <th>SL NO</th>

                            <th>
                              Used SubCategory

                            </th>
                            <th>Pay Amount(<i className="fa fa-inr" />)</th>
                            <th>Date</th>
                            <th>Up 1 Distribution	</th>
                            <th>Up 2 Distribution</th>
                            <th>Total Distribution</th>
                            <th>Net Profit(<i className="fa fa-inr" />)</th>


                          </tr>
                        </thead>
                        <tbody>

                          {
                            meberdetails?.map((item, index) => {
                              const serialNumber = (currentPage - 1) * getLimit + index + 1;
                              return (
                                <tr>
                                  <td 
                                   style={{
                                                            backgroundColor: item?.is_renue == 1? '#c0cfc4' : '',
                                                            color: '#000000',
                                                        }}
                                  >{index + 1}</td>
                                  <td   style={{
                                                            backgroundColor: item?.is_renue == 1? '#c0cfc4' : '',
                                                            color: '#000000',
                                                        }}>
                                    {item?.sub_category_name}
                                  </td>
                                  <td style={{
                                    textAlign: 'center',
                                     backgroundColor: item?.is_renue == 1? '#c0cfc4' : '',
                                                            color: '#000000',
                                  }}>{item?.price}</td>
                                  <td  style={{
                                                            backgroundColor: item?.is_renue == 1? '#c0cfc4' : '',
                                                            color: '#000000',
                                                        }}>{moment(item?.date).format('DD-MM-YYYY')}</td>

                                  <td style={{
                                    textAlign: 'center',
                                     backgroundColor: item?.is_renue == 1? '#c0cfc4' : '',
                                                            color: '#000000',
                                  }}>{item?.level_1_commission}</td>
                                  <td style={{
                                    textAlign: 'center',
                                     backgroundColor: item?.is_renue == 1? '#c0cfc4' : '',
                                                            color: '#000000',
                                  }}>{item?.level_2_commission}</td>
                                  <td style={{
                                    textAlign: 'center',
                                     backgroundColor: item?.is_renue == 1? '#c0cfc4' : '',
                                                            color: '#000000',
                                  }}> {item?.total_distribution}</td>
                                  <td style={{
                                    textAlign: 'center',
                                     backgroundColor: item?.is_renue == 1? '#c0cfc4' : '',
                                                            color: '#000000',
                                  }}>{item?.profit}</td>


                                  {/* <td>

                              <i
                                class="fa fa-eye"
                                data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight" aria-controls="offcanvasRight"
                                aria-hidden="true"></i>
                            </td> */}


                                </tr>
                              )
                            })
                          }
                          <tr>
                            <td></td>
                            <td>

                            </td>
                            <td style={{
                              textAlign: 'center',
                               
                            }}>TO: {totalpayammount_detai?.payamount}</td>
                            <td className="prioce_itd"> ---</td>

                            <td style={{
                              textAlign: 'center',
                               
                            }}>To: {totalpayammount_detai?.up1_amount}</td>
                            <td style={{
                              textAlign: 'center',
                               
                            }}>To: {totalpayammount_detai?.up2_amount}</td>
                            <td style={{
                              textAlign: 'center',
                               
                            }}>To: {totalpayammount_detai?.Total_dis}</td>
                            <td style={{
                              textAlign: 'center',
                               
                            }}>To: {totalpayammount_detai?.net_profit}</td>
                            {/* <div className='table-column'>


                              <i
                                class="fa fa-eye"
                                data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight" aria-controls="offcanvasRight"
                                aria-hidden="true"></i>
                            </div> */}
                          </tr>
                        </tbody>
                      </table>
                      <div className='nodata-found-div'>
                        {
                          meberdetails?.length == 0 ?
                            <p>No Data Found</p>
                            //  <img 
                            //  className='table-image'
                            //  src={require('../../assets/OIP.png')}/>
                            : null
                        }
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            )
        }

      </div>

    </>
  )
}
export default ProfitServiceUser